module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('i', [_vm._v("To\n\t\t\t\t\tmy Granddaughters Five:")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Lillian Rose, Violet Marie, Charlotte Elizabeth,")]), _vm._v(" "), _c('br'), _c('i', [_vm._v("Gretchen Jane, and Madeleine Elizabeth")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f69f154e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Goldsborough_TerrorAtTheFair_1P-2.vue
// module id = 72
// module chunks = 0